import en from './en.json'
import it from './it.json'

export const operatorAuditTranslations = {
	en,
	it
} as const
